import { extend } from 'flarum/common/extend';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import formatPrice from '../common/utils/formatPrice';
import labelClass from '../common/utils/labelClass';
import labelText from '../common/utils/labelText';
export default function addListingMeta() {
  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs?.discussion;
    if (!discussion || !discussion.isClassifieds || !discussion.isClassifieds()) return;
    const price = formatPrice(discussion.listingPrice(), discussion.listingPriceMax(), discussion.listingCurrency());
    if (price) {
      items.add('classifiedsPrice', m("span", {
        className: "ClassifiedsListMeta-price"
      }, price), 90);
    }
    if (discussion.listingLocation()) {
      items.add('classifiedsLocation', m("span", {
        className: "ClassifiedsListMeta-location"
      }, m("i", {
        className: "icon fas fa-map-marker-alt"
      }), " ", discussion.listingLocation()), 85);
    }
    if (discussion.listingLabel()) {
      items.add('classifiedsLabel', m("span", {
        className: labelClass(discussion.listingLabel())
      }, labelText(discussion.listingLabel())), 100);
    }
  });
}